import React, { useState, useMemo } from 'react'

const Pagination = ({ page, pageCount, canPreviousPage, canNextPage, onClick }) => {
  const [currentPage, setCurrentPage] = useState(page)

  const handleClick = (pageNumber) => {
    setCurrentPage(pageNumber)
    onClick(pageNumber)
  }

  const pageNumbers = useMemo(() => {
    const numbers = []

    let start = currentPage - 2, end = currentPage + 2

    if (end > pageCount) {
      start -= (end - pageCount)
      end = pageCount
    }

    if (start <= 0) {
      end += ((start - 1) * (-1))
      start = 0
    }

    end = end > pageCount ? pageCount : end

    for (let i = start; i < end; i++) numbers.push(i)

    return numbers
  }, [currentPage, pageCount])

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination">
        <li className="first">
          <button disabled={!canPreviousPage} onClick={() => handleClick(0)} aria-label="First">
            <span aria-hidden="true">&larr;</span> Primeira
          </button>
        </li>
        <li className="prev">
          <button disabled={!canPreviousPage} onClick={() => handleClick(currentPage - 1)} aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        {pageNumbers.map((pageNumber) => (
          <li className={'page' + (pageNumber === currentPage ? ' active' : '')} key={pageNumber}>
            <button onClick={() => handleClick(pageNumber)}>{pageNumber + 1}</button>
          </li>
        ))}
        <li className="next">
          <button disabled={!canNextPage} onClick={() => handleClick(currentPage + 1)} aria-label="Next">
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
        <li className="last">
          <button disabled={!canNextPage} onClick={() => handleClick(pageCount - 1)} aria-label="Last">
            Última <span aria-hidden="true">&rarr;</span>
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default Pagination